
import { Injectable } from '@angular/core';
import { ProcurementProjectLotDTO } from '../../api/plyca-dtos-v2';
import { FormService } from '../../components/forms/form.service';

export enum PartialCopyOptions {
  SOLVENCY = 'SOLVENCY',
  CANDIDATE_CRITERIA = 'CANDIDATE_CRITERIA',
  AWARD_CRITERIA = 'AWARD_CRITERIA',
  OUTSOURCING = 'OUTSOURCING',
  DELAY_PENALTIES = 'DELAY_PENALTIES',
  OTHER_PENALTIES = 'OTHER_PENALTIES'
}

@Injectable()
export class ProcurementProjectAYMADUtils {

  constructor(private formService: FormService) {
  }

  /**
   *
   * @param source Metodo que devuelve un objeeto de tipo ProcurementProjectLotDTO con los datos de los grupos de copia seleccionados
   * @param options
   * @returns
   */
  public copyPartialLotInfo(source: ProcurementProjectLotDTO, destination: ProcurementProjectLotDTO
    , options: PartialCopyOptions[]): void {

    if (options.find(option => option === PartialCopyOptions.SOLVENCY)) {
      this.copySolvencyData(destination, source);
    }
    if (options.find(option => option === PartialCopyOptions.CANDIDATE_CRITERIA)) {
      this.copyCandidateyCriteriaData(destination, source);
    }
    if (options.find(option => option === PartialCopyOptions.AWARD_CRITERIA)) {
      this.copyAwardCriteriayData(destination, source);
    }
    if (options.find(option => option === PartialCopyOptions.OUTSOURCING)) {
      this.copyOutsourcingData(destination, source);
    }
    if (options.find(option => option === PartialCopyOptions.DELAY_PENALTIES)) {
      this.copyDelayPenaltiesData(destination, source);
    }
    if (options.find(option => option === PartialCopyOptions.OTHER_PENALTIES)) {
      this.copyOtherPenaltiesData(destination, source);
    }
    /*if (options.find(option => option === PartialCopyOptions.TEST)) {
      // array de cpv
      this.copyPathData(destination, source, 'cpvs');
      // array de objetos con referencias a otros expedientes
      this.copyPathData(destination, source, 'selectionAwardCriteria');
      // actualizar referencias a expediente
      if (destination.selectionAwardCriteria) {
        destination.selectionAwardCriteria.forEach(award => award.project = destination.project)
      }
      // propiedad string
      this.copyPathData(destination, source, 'description');
      // propiedad fecha
      this.copyPathData(destination, source, 'tenderingTerm.tenderValidityPeriod');
    }*/
  }


  // ***************************************************************************
  // II.C - Solvencia
  // *** Criterios de seleccion de candidatos
  private copySolvencyData(destination: ProcurementProjectLotDTO, source: ProcurementProjectLotDTO) {
    // Tabla Medios de solvencia
    this.copyPathData(destination, source, 'criteriaTechnicalFinancial');
    // FichaExpedienteOD.OTROSMEDSOL - othersCriteriaTechnicalFinancial - (Suministros)
    this.copyPathData(destination, source, 'othersCriteriaTechnicalFinancial');
    // Panel Adscripción de medios personales y materiales
    // modelFExped1.MEDPERSCONT - requiredMedPers
    this.copyPathData(destination, source, 'requiredMedPers');
    // modelFExped2.MEDPERSMATCONT - engagementMedPersMat
    this.copyPathData(destination, source, 'engagementMedPersMat');
    // modelFExped_AYMAD.MED_PERS_MAT - medPersMatType
    this.copyPathData(destination, source, 'medPersMatType');
    // modelFExped_AYMAD.DESC_MED_PERS_MAT - medPersMatDesc
    this.copyPathData(destination, source, 'medPersMatDesc');
  }

  // ***************************************************************************
  // II.D - Criterios de adjudicacion
  // *** Criterios de seleccion de candidatos
  private copyCandidateyCriteriaData(destination: ProcurementProjectLotDTO, source: ProcurementProjectLotDTO) {
    // FICHAEXPTE1.CRITERIOSPOND - selectionCriteriaDesc
    this.copyPathData(destination, source, 'selectionCriteriaDesc');

  }

  // *** Criterios de adjudicacion
  private copyAwardCriteriayData(destination: ProcurementProjectLotDTO, source: ProcurementProjectLotDTO) {
    // FICHAEXPTE1.CRITERIOSADJ - objectiveCriteriaDesc
    this.copyPathData(destination, source, 'objectiveCriteriaDesc');
    // FICHAEXPTE_AYMAD.EXISTEN_CRITERIOS -  existSubjectiveCriteria
    this.copyPathData(destination, source, 'existSubjectiveCriteria');
    // FICHAEXPTE1.CRITERIOSADJ2 -  subjectiveCriteriaDesc
    this.copyPathData(destination, source, 'subjectiveCriteriaDesc');
  }
  // Fin II.D *********************************************************************************************


  // ***************************************************************************
  // II.j - subcontratacion
  private copyOutsourcingData(destination: ProcurementProjectLotDTO, source: ProcurementProjectLotDTO) {
    let procurementProjectLot: any;
    procurementProjectLot = destination;
    // Si se ha seleccionado subcontratacion en el lote destino. Si no no copia. Tal cual en el applet.
    if (procurementProjectLot.subContractTerm && procurementProjectLot.subContractTerm?.authorized) {
      // LOTE_EXT.PORC_SUBCON_TOTAL - extLotTotalPercentageSubcontracted
      this.copyPathData(destination, source, 'extLotTotalPercentageSubcontracted');

      // LOTE_EXT.PORC_SUBCON_RESERVA - extLotReservedPercentageSubcontracted
      this.copyPathData(destination, source, 'extLotReservedPercentageSubcontracted');

      // modelFExped_AYMAD.OBLIGPARTESUBCONT_SERV - subContractTerm.servicesTendererOblig
      this.copyPathData(destination, source, 'subContractTerm.obligationSubcontract');

      // modelFExped2.PENALIDADES_INFR_SUBCONT - subContractTerm.condNonCompPenalties
      this.copyPathData(destination, source, 'subContractTerm.condNonCompPenalties');

      // modelFExped2.DESC_PENALIDADES_INFR_SUBCONT - subContractTerm.condNonCompPenaltiesDesc
      this.copyPathData(destination, source, 'subContractTerm.condNonCompPenaltiesDesc');

      // modelFExped2.PENALIDADES_INCUM_PAGOS - subContractTerm.paymentNonCompPenalties
      this.copyPathData(destination, source, 'subContractTerm.paymentNonCompPenalties');

      // modelFExped2.DESC_PENALIDADES_INCUM_PAGOS - subContractTerm.paymentNonCompPenaltiesDesc
      this.copyPathData(destination, source, 'subContractTerm.paymentNonCompPenaltiesDesc');
    }
  }
  // Fin II.J *********************************************************************************************


  // ***************************************************************************
  // II.k - penalidades
  // ***  Panel Demora en ejecucion
  private copyDelayPenaltiesData(destination: ProcurementProjectLotDTO, source: ProcurementProjectLotDTO) {
    // FICHAEXPTE.PENALIZALCAP - execution.penaltyClausesPeriod
    this.copyPathData(destination, source, 'execution.penaltyClausesPeriod');
    // FICHAEXPTE.CUMPLAZOS - execution.penaltyClausesOther
    this.copyPathData(destination, source, 'execution.penaltyClausesOther');
  }

  // *** Panel Incumplimento parcial o cumplimiento defectuoso
  private copyOtherPenaltiesData(destination: ProcurementProjectLotDTO, source: ProcurementProjectLotDTO) {
    // FICHAEXPTE_AYMAD.CUMPL_DEFECTUOSO - FICHAEXPTE.INCUMPARC
    // execution.faultyCompliance - execution.faultyExecPenaltiesDes
    this.copyPathData(destination, source, 'execution.faultyCompliance');
    this.copyPathData(destination, source, 'execution.faultyExecPenaltiesDesc');

    // modelFExped_AYMAD.INC_MED_PERS_MAT - modelFExped_AYMAD.DESC_INC_MED_PERS_MAT
    // execution.agreementUnfulfillment - execution.agreementUnfulfillmentDesc
    this.copyPathData(destination, source, 'execution.agreementUnfulfillment');
    this.copyPathData(destination, source, 'execution.agreementUnfulfillmentDesc');

    // modelFExped_AYMAD.COND_ESP_EJEC_PENALIDADES - modelFExped1.TEXTO_PENALIDADES
    // execution.executionSpecialCondition - execution.executionSpecialConditionDesc
    this.copyPathData(destination, source, 'execution.executionSpecialCondition');
    this.copyPathData(destination, source, 'execution.executionSpecialConditionDesc');

    // modelFExped_AYMAD.PEN_COND_ESP_EJEC - modelFExped_AYMAD.DESC_PEN_COND_ESP_EJEC
    // execution.awardCriteriaUnfulfillment - execution.awardCriteriaUnfulfillmentDesc
    this.copyPathData(destination, source, 'execution.awardCriteriaUnfulfillment');
    this.copyPathData(destination, source, 'execution.awardCriteriaUnfulfillmentDesc');

    // modelFExped_AYMAD.INC_OBLIG_SUBROGACION - modelFExped_AYMAD.DESC_INC_OBLIG_SUBROGACION
    // execution.subrogationUnfulfillment - execution.subrogationUnfulfillmentDesc
    this.copyPathData(destination, source, 'execution.subrogationUnfulfillment');
    this.copyPathData(destination, source, 'execution.subrogationUnfulfillmentDesc');

    // modelFExped_AYMAD.INC_OBLIG_MEDIOAMBIENTAL - modelFExped_AYMAD.DESC_INC_OBLIG_MEDIOAMBIENTAL
    // execution.environmentalObligation - execution.environmentalObligationDesc
    this.copyPathData(destination, source, 'execution.environmentalObligation');
    this.copyPathData(destination, source, 'execution.environmentalObligationDesc');
  }
  // Fin II.k *********************************************************************************************

  private copyPathData(destination: ProcurementProjectLotDTO, source: ProcurementProjectLotDTO, path: string) {
    this.formService.setNestedProperty(destination, path, this.formService.getNestedProperty(source, path));
  }

}
